import {action, computed, observable, runInAction} from "mobx";
import BasePaginationStore from "@store/Common/BasePaginationStore";
import service from '@service/index';
import fetchUrl from '@service/fetchUrl';
import {message} from 'antd';
import CustomerTypeSelect from "@ViewsDashboard/Common/CustomerTypeSelect";
import MyAgentStore from '@store/LoginUser/MyAgentStore';

class Item {
    constructor(data) {
        this.init(data);
    }

    @action
    init(data) {
        if (data == undefined) {
            return
        }
        for (let attr in data) {
            this[attr] = data[attr];
        }
    }

    // 交易号
    @observable
    id = "";

    // 订单号
    @observable
    number_no = "";

    // 购彩人
    @observable
    pet_name = "";

    // 彩种
    @observable
    type = "";

    @computed
    get type_name() {
        switch (this.type) {
            case 1:
                return '双色球';
            case 2:
                return '大乐透';
            case 3:
                return '福彩3D';
            case 4:
                return '排列三';
            case 5:
                return '排列五';
            case 6:
                return '重庆时时彩';
            case 7:
                return '上海时时乐';
            case 8:
                return '七星彩';
            case 9:
                return '七彩乐';
            case 10:
                return '足球14场';
            case 11:
                return '足球任9';
            case 12:
                return '竞彩足球';
            case 13:
                return '四场进球';
            case 14:
                return '6场半全场';
            case 15:
                return '竞彩篮球';
            case 16:
                return '老11选5';
            case 17:
                return '幸运赛车';
            case 22:
                return '北单';
            case 23:
                return '欧亚足球';
            case 20:
                return '竞猜冠军';
            case 21:
                return '竞猜冠亚军';
            default:
                return '未知';
        }
    }

    // 购彩时间
    @observable
    build_time = "";

    // 购彩方式
    @observable
    share_id = "抄单";

    // 方案价
    @observable
    amount = "";

    // 方案价
    @observable
    out_amount = "";

    // 彩金
    @observable
    mosaic_money = "";

    // 实际付款
    @observable
    actual_pay = '';

    // 中奖金额
    @observable
    win_money = "";

    // 出票状态
    @observable
    status = "";

    @computed
    get status_name() {
        switch (this.status) {
            case 0:
                return '待拆票';
            case 1:
                return '待出票';
            case 2:
                return '出票中';
            case 3:
                return '出票成功';
            case 4:
                return '部分出票成功';
            case 5:
                return '出票失败';
            case 6:
                return '未中奖';
            case 7:
                return '已中奖';
            default:
                return '未知';
        }
    }

    @computed
    get is_win() {
        return this.status_name == '已中奖';
    }


}

class Pagination_store extends BasePaginationStore {

}

/**
 * 页面头部筛选过滤器字段值
 **/

class FilterStore {
    //是否初始化过
    is_init;
    search;
    type;
    proxy_type = CustomerTypeSelect.getTypeId(CustomerTypeSelect.TYPE_AGENT_ALL);
    //代理昵称
    agent;
    nick_name;
    pet_name;
    id;
    type_time

    @action
    setAttr({agent, search, nick_name, type, pet_name, id, type_time}) {
        this.resetAttr();
        this.search = search;
        this.type = type;
        this.id = id;
        if (pet_name != '' || pet_name != undefined) {
            this.nick_name = nick_name;
            this.pet_name = pet_name;
        }
        if (agent != undefined || agent != '') {
            this.agent = agent;
            this.id = MyAgentStore.findMyAgentId(agent);
        }
        this.type_time = type_time;
        this.is_init = true;
    }

    getAttr() {
        return {
            search: this.search,
            nick_name: this.nick_name,
            pet_name: this.pet_name,
            type: this.type,
            id: this.id,
            proxy_type: this.proxy_type,
            type_time: this.type_time
        }
    }

    setDefault(type) {
        this.resetAttr();
        this.type = type;
        this.proxy_type = 2;
        this.is_init = true;
    }

    @action
    resetAttr() {
        this.search = undefined;
        this.id = undefined;
        this.type = undefined;
        this.proxy_type = undefined;
        this.nick_name = undefined;
        this.pet_name = undefined;
        this.type_time = 6;
        this.is_init = undefined;
    }
}

let filter_store = new FilterStore();

class Item_store {
    constructor(pagination) {
        this.init(pagination);
    }

    @action
    init(pagination) {
        this.pagination_store = pagination;
    }

    @observable
    item_map = new Map();

    @observable
    pagination_store;

    /**
     * item 数组列表
     */
    @computed
    get item_array() {
        let res = [];
        this.item_map.forEach((values, key) => {
            res.push(values);
        });
        return res;
    }

    /**
     * 编辑中的 item
     */
    @observable
    editting_item = new Item();

    /**
     * 控制编辑 modal 是否显示
     */
    @observable
    is_edit_modal_show = true;

    /**
     * 打开 modal 显示
     */
    @action
    openEditModal() {
        this.is_edit_modal_show = true;
    }

    /**
     * 关闭 modal 显示
     */
    @action
    closeEditModal() {
        this.editting_item = new Item();
        this.is_edit_modal_show = false;
    }


    @action
    reloadDatas(filter) {
        this.new_num = 0;
        this.new_total = 0;
        this.pagination_store.clear();
        if (filter == undefined) {
            if (filter_store.is_init == undefined) {
                filter_store.setDefault()
            }
        } else {
            filter_store.setAttr(filter);
        }

        this.searchByFilter(
            {
                desc: 1,
                order: 'build_time'
            }
        );
    }

    /**
     * 根据条件搜索item
     */
    async searchByFilter(page_opts) {
        let page_option = {
            page: this.pagination_store.page_cur,
            page_size: this.pagination_store.page_size,
            ...filter_store.getAttr(),
            ...page_opts
        }
        let res = await this.getItemArray(page_option);
        return res;
    }

    /**
     * 获取item 列表
     */
    async getItemArray(page_option = {}) {
        let url = fetchUrl.admin.memberPurchase;
        let res = await service.fetchData({
            path: url,
            params: {
                ...page_option
            }
        });
        service.responseHandle({
            res: res,
            success_handle: (res) => {
                runInAction(() => {
                    this.item_map.clear();
                    res.data.data.forEach((item, index) => {
                        this.item_map.set(item.id, new Item(item));
                    });
                    this.pagination_store.setAttr(res.data.page);
                })
            },
            fail_handle: (res) => {
                message.error(res.error.error_data, 3);
                this.pagination_store.clear();
                filter_store.resetAttr();
                this.item_map.clear();
            }
        });
        return res;
    }
}

let pagination_store = new Pagination_store();
let item_store = new Item_store(pagination_store)
export {
    pagination_store,
    filter_store,
}
export default item_store;



// WEBPACK FOOTER //
// ./src/Store/Purchase/MemberPurchaseStore.js